var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 127,
    x: 0.5,
    y: 0.5,
    fill: "#EE2722",
    stroke: "#EE2722",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M77.229 46.067h13.055c8.016 0 14.514 6.456 14.514 14.421 0 7.965-6.498 14.421-14.514 14.421h-.538v7.935H77.184v-6.33a18.445 18.445 0 0 1-13.908 6.33H51.207v-7.935h-9.736l-4.62 7.935H22.134l21.67-36.777h19.47a18.354 18.354 0 0 1 13.909 6.33l.045-6.33Zm7.94 24.295h5.115c5.489 0 9.938-4.42 9.938-9.874 0-5.453-4.45-9.874-9.938-9.874h-8.48v11.813H77.14c-1.025-6.788-6.91-11.8-13.818-11.769H46.586l-16.33 27.639h3.723l4.71-7.935h17.05v7.935l7.537-.045c5.383.01 10.291-3.061 12.607-7.89h5.877v7.935h3.41v-7.935Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.356 62.427h7.851v-8.425h4.576v12.972H40.71l2.647-4.547Zm19.965-8.403h-4.128v4.502h4.128c1.594 0 3.123.63 4.25 1.75a5.954 5.954 0 0 1 1.761 4.224 5.879 5.879 0 0 1-1.77 4.189 5.956 5.956 0 0 1-4.241 1.695s-4.128-.044-4.128 0v4.547h4.128c5.81 0 10.52-4.68 10.52-10.453 0-5.774-4.71-10.454-10.52-10.454Zm26.963 0H85.17v4.502h5.114c1.09 0 1.974.879 1.974 1.962a1.968 1.968 0 0 1-1.974 1.961H85.17v4.503h5.114c3.593 0 6.506-2.894 6.506-6.464 0-3.57-2.913-6.464-6.506-6.464Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdpLogo);
export default __webpack_public_path__ + "static/media/adpLogo.af59bed436d43e2fc5ded0c423e80e19.svg";
export { ForwardRef as ReactComponent };